var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"event-procedure"},[_c('event-detail-title',{attrs:{"type":_vm.anchorMap.PROCEDURE_KEY}}),_c('div',{staticClass:"section-content"},[_c('markdown-beautiful',{attrs:{"data":_vm.events_procedure_html}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }